<template>
    <div class="plc">
        <div class="row">
            <div :class="type === 'All' ? 'col-lg-9' : 'col-lg-12'">
                <div class="plc__filter" v-if="['All', 'Filter'].indexOf(type) > -1">
                    <div class="plc__city">
                        <div class="plc__item plc__item--one"></div>
                        <div class="plc__item plc__item--two"></div>
                        <div class="plc__item plc__item--three"></div>
                    </div>
                    <div class="plc__item plc__item--filter">
                    </div>
                    <div class="plc__type">
                        <div class="plc__item plc__item--1"></div>
                        <div class="plc__item plc__item--2"></div>
                        <div class="plc__item plc__item--3"></div>
                        <div class="plc__item plc__item--4"></div>
                        <div class="plc__item plc__item--5"></div>
                    </div>
                </div>
                <div class="plc__nums" v-if="['All', 'Numbers'].indexOf(type) > -1">
                    <div class="plc__header">
                        <div class="plc__current plc__item"></div>
                        <div class="plc__random">
                            <div class="plc__item plc__icon"></div>
                            <div class="plc__item plc__txt"></div>
                        </div>
                    </div>
                    <div class="plc__price">
                        <div class="plc__item plc__abon"></div>
                        <div class="plc__item plc__once"></div>
                    </div>
                    <div class="plc__grid">
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                    </div>
                    <div class="plc__grid">
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                        <div class="plc__col">
                            <div class="plc__item plc__sm"></div>
                            <div class="plc__item plc__lg"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3" v-if="type === 'All'">
                <div class="plc__item plc__cart"></div>
            </div>
        </div>
    </div>
</template>

<script>


/* global $ */

export default {
    name: 'SkeletonNumbers',
    props: {
        type: String, //All, Filter, Numbers
        default: 'All'
    }
}
</script>

<style lang="scss">
@keyframes pulse {
    0% {
        background-position: -32px;
    }
    50%, 100% {
        background-position: 250px;
    }
}


.vp  + .plc {
    margin-top: -100px;
}

.motivation-tooltip {
    display: none!important;
}


.plc__item {
    background-image: linear-gradient(90deg, #E4E8EB 0px, #fff 40px, #E4E8EB 80px);
    background-size: 600px;
    animation: pulse 2s infinite;
    display: inline-block;
    border-radius: 3px;
}

.plc__city {
    padding-top: 16px;
}

.plc__item--one {
    margin: 0 5px 5px 0;
    width: 96px;
    height: 34px;
}

.plc__item--two {
    margin: 0 5px 5px 0;
    width: 167px;
    height: 34px;
}

.plc__item--three {
    margin: 0 5px 5px 0;
    width: 156px;
    height: 34px;
}

.plc__item--filter {
    display: block;
    margin: 20px 0;
    height: 72px;
}

.plc__type {
    margin-top: 20px;
}

.plc__item--1 {
    margin: 0 10px 10px 0;
    border-radius: 25px;
    width: 125px;
    height: 23px;
}

.plc__item--2 {
    margin: 0 10px 10px 0;
    border-radius: 25px;
    width: 160px;
    height: 23px;
}

.plc__item--3 {
    margin: 0 10px 10px 0;
    border-radius: 25px;
    width: 145px;
    height: 23px;
}

.plc__item--4 {
    margin: 0 10px 10px 0;
    border-radius: 25px;
    width: 162px;
    height: 23px;
}

.plc__item--5 {
    margin: 0 10px 10px 0;
    border-radius: 25px;
    width: 171px;
    height: 23px;
}

.plc__header {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    margin-bottom: 20px;
}

.plc__current {
    width: 105px;
    height: 21px;
    flex-shrink: 0;
}

.plc__icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
}

.plc__txt {
    width: 133px;
    height: 24px;
}

.numbers-type_main {
    min-height: 70px;
}

.plc__price {
    height: 28px;
}

.plc__abon {
    width: 112px;
    height: 16px;
    margin-right: 3px;
}

.plc__once {
    width: 272px;
    height: 16px;
}

.plc__grid {
    display: flex;
    flex-flow: row wrap;
    margin-top: 20px;
}

.plc__col {
    display: flex;
    width: 25%;
    margin-top: 14px;
    margin-bottom: 24px;
}

.plc__sm {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}


.plc__lg {
    width: 100px;
    height: 16px;
}

.plc__cart {
    display: block;
    padding-bottom: 100%;
}



.empty-numbers {
    color: #CCC;
}

.empty-numbers--icon {
    text-align: center;
    font-size: 172px;
    line-height: 172px;
}

.empty-numbers--text {
    font-size: 24px;
}

@media (max-width: 420px) {
    .empty-numbers--text {
        padding-top: 0;
        font-size: 26px;
        text-align: center;
    }
}

.mini-basket-price {
    font-weight: 700;
}

.left-cart-price {
    font-size: 13px;
    margin-top: 10px;
}
.cart-group-row{
    margin-bottom: 16px;
}

.sel-vats {
    font-size: 14px;
    color: #777;
    text-align: center;
    padding: 10px 15px;
    margin-top: 25px;
}
.sel-vats span {
    margin-right: 5px;
}
@media (max-width: 767px) {
    .sel-vats {
        text-align: left;
        padding: 15px;
    }

    .sel-vats span {
        display: block;
        margin-bottom: 10px;
    }
}
@media (max-width: 375px) {
    .sel-vats select {
        width: 100%;
    }
}
.fms-logo {
    margin-top: 35px;
}
</style>